<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="sync" />
          {{ $t('mappingZaloUser') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="search"
                          :placeholder="$t('keyword')"></b-form-input>
            <client-select class="mr-1 mb-1" :model="filterFormModel" attribute="client"
                           @change="search" :isFilter="true" :place-holder="$t('selectClient')"></client-select>
            <social-net-work-account-select :place-holder="$t('chooseZaloUser')" :model="filterFormModel"
                                            class="mr-1 mb-1" attribute="account"
                                            @change="search" :isFilter="true" :filter="oaFilter" :is-filter="true" />
            <time-range-picker :model="filterFormModel" :label="$t('time')" class="mr-1 mb-1"
                               :defaultShortcut="3"></time-range-picker>
            <button @click="search" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="mb-3" v-if="checkedItems.length">
          <b-dropdown id="dropdown-left" :text="$t('selected', [checkedItems.length])" variant="secondary"
                      size="sm">
            <b-dropdown-item @click="showDelete = true">{{ $t('delete') }}</b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount > 0">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length > 0">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title check-row">
            <div class="col-lg-1"></div>
            <div class="col-lg-3 check-column">
              Client
              <b-form-checkbox :class="`check-form ${checkedItems.length === items.length ? '' : 'hide'}`"
                               v-model="selectAll" @change="select"></b-form-checkbox>
            </div>
            <div class="col-lg-3">{{ $t('customer') }}</div>
            <div class="col-lg-3">{{ $t('time') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row check-row" v-for="item in items" :key="item._id">
            <div class="col-lg-1">
              <figure class="c-board-table__avatar">
                <img v-if="item.avatar" v-bind:src="item.avatar" :alt="item.name" class="thumbnail" />
                <img v-else src="/img/default-avatar.png" :alt="item.name" class="thumbnail" />
              </figure>
            </div>
            <div class="col-lg-3 check-column">
              <b-form-checkbox
                :class="`check-form ${checkedItems.find(checkedItem => checkedItem._id === item._id) ? '' : 'hide'}`"
                :value="item" v-model="checkedItems" @change="updateCheckAll"></b-form-checkbox>
              <p v-if="item.client">
                <b>Domain: </b>
                <span>{{ item.client.domain }}</span>
              </p>
              <p v-if="item.account">
                <b>{{ $t('zaloUser') }}: </b>
                <span>{{ item.account.name }}</span>
              </p>
              <p v-if="item.account">
                <b>{{ $t('number') }}: </b>
                <span v-if="item.account.zaloId">{{ item.account.zaloId }}</span>
                <span v-else>{{ $t('notUpdate') }}</span>
              </p>
            </div>
            <div class="col-lg-3">
              <p>
                <b>{{ $t('customerNameCallio') }}: </b>
                <span v-if="item.customer">{{ item.customer.name }}</span>
                <span v-else>{{ $t('unknown') }}</span>
              </p>
              <p>
                <b>{{ $t('customerNameZalo') }}: </b>
                <span v-if="item.name">{{ item.name }}</span>
                <span v-else>{{ $t('unknown') }}</span>
              </p>
              <p>
                <b>{{ $t('number') }}: </b>
                <span v-if="item.phone">{{ item.phone }}</span>
                <span v-else>{{ $t('notUpdate') }}</span>
              </p>
            </div>
            <div class="col-lg-3">
              <p>
                <b>{{ $t('createTime') }}:&nbsp;</b>
                <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
              <p>
                <b>{{ $t('updateTime') }}:&nbsp;</b>
                <span>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
            </div>
            <div class="col-lg-2">
              <div class="c-buttons__col">
                <button @click="del(item._id)"
                        class="btn btn-danger btn-sm" type="button">
                  <font-awesome-icon icon="trash" />
                  {{ $t('delete') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="items.length === 0 && !loading">{{
          $t('notFoundSearch')
        }}
      </div>
      <div class="col-12" v-if="itemCount > 0">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                        v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                        @input="load">
          </b-pagination>

        </div>
      </div>
    </div>
    <b-modal v-model="showDelete" no-close-on-backdrop scrollable :title="$t('massDelete')" size="lg">
      <p>{{ $t('listToDelete') }}</p>
      <div class="c-template-table table-responsive mb-0">
        <table class="table table-bordered table-more table-hover">
          <thead>
          <tr>
            <th class="text-center">#</th>
            <th>{{ $t('customerNameCallio') }}</th>
            <th>{{ $t('customerNameZalo') }}</th>
            <th>{{ $t('phone') }}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data, index) in checkedItems" :key="data._id">
            <td class="text-center">{{ index + 1 }}</td>
            <td>
              <div v-if="data.customer">{{ data.customer.name }}</div>
              <div v-else>{{ $t('notUpdate') }}</div>
            </td>
            <td>{{ data.name }}</td>
            <td>
              <div v-if="data.phone">{{ data.phone }}</div>
              <div v-else>{{ $t('notUpdate') }}</div>
            </td>
            <td class="text-center">
              <span :for="`result_${data._id}`"></span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="close">
          {{ $t('cancel') }}
        </b-button>
        <b-button :disabled="deleteLoading" variant="primary" class="float-right" @click="startDelete">
          <b-spinner v-if="deleteLoading" small></b-spinner>
          {{ $t('delete') }}
        </b-button>
      </template>
    </b-modal>
  </main>
</template>

<script>
import list from '@/mixins/List'
import crud from '@/mixins/CRUD'
import utils from '@/utils'
import ClientSelect from '@/components/ClientSelect'
import TimeRangePicker from '@/components/TimeRangePicker'
import SocialNetWorkAccountSelect from '@/components/SocialNetWorkAccountSelect'
import _ from 'lodash'
import $ from 'jquery'

export default {
  components: { TimeRangePicker, ClientSelect, SocialNetWorkAccountSelect },
  mixins: [list, utils, crud],
  data() {
    return {
      service: '/zalo-user',
      autoLoad: true,
      oaFilter: {
        type: 'zalo-user',
        client: null
      },
      defaultFilterFormModel: {
        client: null,
        keyword: null,
        account: null
      },
      showDelete: false,
      deleteLoading: false,
      selectAll: false,
      checkedItems: []
    }
  },
  methods: {
    search: _.debounce(function() {
      this.filterFormModel.page = 1
      this.load()
    }, 200),
    select() {
      this.checkedItems = []
      if (this.selectAll) {
        this.items.forEach((item, index) => {
          this.checkedItems.push(this.items[index])
        })
      }
    },
    updateCheckAll() {
      this.selectAll = this.items.length === this.checkedItems.length
    },
    async startDelete() {
      this.deleteLoading = true
      let i = 0
      let successCount = 0
      $(`span[for^=result]`).html('<div class="spinner-border spinner-border-sm text-primary" role="status"><span class="sr-only">Loading...</span></div>')

      while (this.showDelete && i < this.checkedItems.length) {
        let data = this.checkedItems[i]
        i++
        try {
          let response
          response = await this.$bgService.delete(this.service + '/' + data._id)
          if (response) {
            successCount++
            $(`span[for=result_${data._id}]`).html(`<span class="badge badge-success">${this.$t('success')}</span>`)
          } else {
            $(`span[for=result_${data._id}]`).html(`<span class="badge badge-danger">${this.$t('fail')}</span>`)
          }
        } catch (e) {
          $(`span[for=result_${data._id}]`).html(`<span class="text-danger">${e.response.data.message}</span>`)
        }
      }
      if (successCount === this.checkedItems.length) {
        this.$swal({
          title: this.$t('success'),
          text: this.$t('deleted'),
          icon: 'success',
          toast: true,
          position: 'top-end',
          timer: 5000
        })
      }
      this.showDelete = false
      this.deleteLoading = false
      this.selectAll = false
      this.checkedItems = []
      this.load()
    },
    close() {
      this.showDelete = false
      this.selectAll = false
      this.checkedItems = []
    }
  },
  i18n: {
    messages: {
      en: {
        time: 'Time',
        createTime: 'Create time',
        mappingZaloUser: 'List of personal Zalo customers',
        customer: 'Customer',
        accountName: 'Account name',
        number: 'Phone number',
        notUpdate: 'Not update',
        customerName: 'Customer name',
        chooseZaloUser: 'Choose personal Zalo',
        zaloUser: 'Personal Zalo',
        customerNameCallio: 'Customer name on Callio',
        customerNameZalo: 'Customer name on Zalo',
        selected: 'Selected {0}',
        massDelete: 'Mass delete',
        listToDelete: 'The customer sync list will be deleted'
      },
      vi: {
        time: 'Thời gian',
        createTime: 'Tạo lúc',
        mappingZaloUser: 'Danh sách KH Zalo cá nhân',
        customer: 'Khách hàng',
        accountName: 'Tên tài khoản',
        number: 'Số điện thoại',
        notUpdate: 'Chưa cập nhật',
        customerName: 'Tên khách hàng',
        chooseZaloUser: 'Chọn Zalo cá nhân',
        zaloUser: 'Zalo cá nhân',
        customerNameCallio: 'Tên KH trên Callio',
        customerNameZalo: 'Tên KH trên Zalo',
        selected: 'Đã chọn {0}',
        massDelete: 'Xoá hàng loạt',
        listToDelete: 'Danh sách đồng bộ khách hàng sẽ bị xoá'
      }
    }
  }
}
</script>

<style>
.c-board-table__avatar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid #fff;
  border-radius: 50%;
}

.c-board-table__avatar img {
  width: auto;
  height: auto;
  min-height: 100%;
  min-width: 100%;
}

.check-column {
  position: relative;
}

.check-form {
  position: absolute;
  top: 0;
  right: 0;
}

.check-form.hide {
  display: none;
}

.check-row:hover .check-form {
  display: block;
}
</style>